export default __webpack_public_path__ + "static/media/SecondView.5fa421df.jpeg";